import type { OptionProps } from '@ps-smart-cp/ppfw-client';
import type { SegmentMstSettingProvider } from '../features/segment-mst';
import { formatTwoDigitNumber } from './numberFormat';

function buildOutputKeySegmentsOptions(segmentMstSettings: SegmentMstSettingProvider[]) {
  const outputKeySegmentsOptions: OptionProps[] = segmentMstSettings.map((segmentSettings) => {
    return {
      optionValue: `segment${formatTwoDigitNumber(segmentSettings.key)}Code`,
      displayValue: segmentSettings.displayName,
    };
  });
  return outputKeySegmentsOptions;
}

function buildOutputKeyCategoryAndSubCategoryOptions(
  categoryOptionValue: string,
  categoryDisplayValue: string,
  subCategoryOptionValue: string,
  subCategoryDisplayValue: string,
) {
  const outputKeyCategoryAndSubCategoryOptions: OptionProps[] = [
    {
      optionValue: categoryOptionValue,
      displayValue: categoryDisplayValue,
    },
    {
      optionValue: subCategoryOptionValue,
      displayValue: subCategoryDisplayValue,
    },
  ];
  return outputKeyCategoryAndSubCategoryOptions;
}

export { buildOutputKeyCategoryAndSubCategoryOptions, buildOutputKeySegmentsOptions };
